<template>
  <div class="container mt-4">
    <div class="card">
      <div class="card-header">
        <h1>Details du Contact</h1>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <section>
              <h4>Informations Personnelles</h4>
              <p><strong>Prénom:</strong> {{ contactDetails.firstname }}</p>
              <p><strong>Nom:</strong> {{ contactDetails.lastname }}</p>
              <p><strong>Email:</strong> {{ contactDetails.email }}</p>
              <p><strong>Civilité:</strong> {{ contactDetails.civilite }}</p>
              <p><strong>État Civil:</strong> {{ contactDetails.etat_civil }}</p>
              <p><strong>Date de Naissance:</strong> {{ contactDetails.birthdate }}</p>
              <p><strong>Nationalité:</strong> {{ contactDetails.nationalite }}</p>
              <p><strong>Adresse Postale:</strong> {{ contactDetails.adresse_postale }}</p>
              <p><strong>Genre:</strong> {{ contactDetails.genre }}</p>
              <p><strong>Code Postal:</strong> {{ contactDetails.code_postal }}</p>
              <p><strong>Ville:</strong> {{ contactDetails.ville }}</p>
              <p><strong>Téléphone:</strong> {{ contactDetails.telephone }}</p>
            </section>
            <section>
              <h4>Autres Informations</h4>
              <p><strong>Métier:</strong> {{ contactDetails.metier }}</p>
              <p><strong>Langue Parlée:</strong> {{ contactDetails.langue_parlee }}</p>
              <p><strong>Autre Téléphone:</strong> {{ contactDetails.autre_telephone }}</p>
              <p><strong>Numéro de Personnes dans le Foyer:</strong> {{ contactDetails.num_personne_foyer }}</p>
              <p><strong>Secteur GF:</strong> {{ contactDetails.secteur_gf }}</p>

              <p><strong>Source:</strong> {{ contactDetails.source_id }}</p>
              <p><strong>Invité(e) par:</strong> {{ contactDetails.invite_par }}</p>
              <p><strong>Date d'inscription:</strong> {{ contactDetails.subscription_date }}</p>
              <p><strong>Conseiller NC:</strong> {{ contactDetails.conseiller_nc }}</p>
              <p><strong>Candidat au programme 31:</strong> {{ contactDetails.est_candidat_prog31 }}</p>
              <p><strong>Converti CEC:</strong> {{ contactDetails.est_converti_cec }}</p>
              <p><strong>Candidat visite:</strong> {{ contactDetails.est_candidat_visite }}</p>
              <p><strong>Observations:</strong> {{ contactDetails.observations }}</p>
              <p><strong>Mineur:</strong> {{ contactDetails.est_mineur }}</p>
              <p><strong>Active:</strong> {{ contactDetails.is_acive }}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userService } from '@/_services';

export default {
  data() {
    return {
      contactDetails: {},
    };
  },
  async created() {
    const contactId = this.$route.params.id;
    try {
      const response = await userService.getUserById(contactId);
      this.contactDetails = response.data;
    } catch (error) {
      console.error('Erreur lors du chargement des détails du contact :', error);
    }
  },
};
</script>
